var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLesotho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4195C0 18.9126 0.570438 21.2725 1.58763 23.376L16 24.0717L30.4124 23.3761C31.4296 21.2725 32 18.9126 32 16.4195C32 13.9264 31.4296 11.5665 30.4124 9.46302L16 8.76733L1.58763 9.46296C0.570438 11.5665 0 13.9264 0 16.4195H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 32.4202C22.3431 32.4202 27.8242 28.7286 30.4122 23.3767H1.5874C4.1754 28.7286 9.6564 32.4202 15.9998 32.4202Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0.419922C9.6564 0.419922 4.1754 4.11148 1.5874 9.46342H30.4121C27.8242 4.11148 22.3431 0.419922 15.9998 0.419922V0.419922Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0438 16.0723V12.2463H14.9569V16.0723L12.4363 18.593C13.1693 19.793 14.4913 20.5941 16.0004 20.5941C17.5095 20.5941 18.8314 19.793 19.5645 18.593L17.0438 16.0723Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.419922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesotho);
export default __webpack_public_path__ + "static/media/lesotho.7f693453.svg";
export { ForwardRef as ReactComponent };